import React from 'react';
import PropTypes from 'prop-types';

import { LabelTooltip } from '../label-tooltip';
import { FormField } from '../form';

const FieldWithTooltip = ({
  label,
  tooltip,
  labelNextToTooltip,
  mode,
  type,
  labelClassName,
  showLabelText = true,
  xs,
  ...props
}) => {
  const complexTooltip = typeof tooltip === 'object';
  const tooltipLabel = complexTooltip ? tooltip.label : 'More info';
  return (
    <LabelTooltip
      label={label}
      mode={mode}
      labelNextToText={labelNextToTooltip}
      tooltip={{
        label: tooltipLabel,
        onHoverText: complexTooltip ? tooltip.onHoverText : tooltip,
        onClick: complexTooltip ? tooltip.onClick : undefined,
        clickIcon: complexTooltip ? tooltip.clickIcon : undefined
      }}
      labelClassName={labelClassName}
      showLabelText={showLabelText}
      xs={xs}
    >
      <FormField {...props} label={showLabelText ? '' : label} mode={mode} type={type} />
    </LabelTooltip>
  );
};

FieldWithTooltip.propTypes = {
  label: PropTypes.string.isRequired,
  mode: PropTypes.oneOf(['light', 'dark']),
  type: PropTypes.string.isRequired,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  labelNextToTooltip: PropTypes.bool
};

FieldWithTooltip.defaultProps = {
  labelNextToTooltip: false,
  mode: 'dark'
};

export default FieldWithTooltip;
